import styled from 'styled-components'
import Section from './Section'

const CenteredSection = styled(Section)`
  text-align: center;
`

export default CenteredSection
